import React from "react";
import {
  defineBlock,
  useEditor,
  ChildrenBlock,
} from "@smartfire/gutenberg-react";
import { InnerBlocks } from "@wordpress/block-editor";
import style from "./block.module.scss";

function Block({ title, image }) {
  const { isEditing } = useEditor();
  return (
    <div className={style.block}>
      <div className={style.content}>
        <div className={isEditing ? style.body : style.children}>
          {isEditing ? (
            <InnerBlocks allowedBlocks={["smartfire/content-image-child"]} />
          ) : (
            <ChildrenBlock />
          )}
        </div>
      </div>
    </div>
  );
}

export default defineBlock({
  Block,
  setup: {
    title: "Contenu Image",
  },
});
